export enum Project {
    CaseManager = 'case-manager',
}